import { ArticlesList } from '../../components';
import { withLayout } from '../../Layout/Layout';
import Head from 'next/head';
import React from 'react';

function News() {
  return (
    <>
      <Head>
        <meta
          name="description"
          content={
            'Stay informed about the latest train travel news and updates on First-Class.com. Explore insights, trends, and luxurious train experiences from around the world'
          }
        />
        <title>Train News: Stay Updated on Luxury Train Travel</title>
      </Head>
      <ArticlesList subtype="News" type="Trains" />
    </>
  );
}

export default withLayout(News, true);
